import React, {CSSProperties} from 'react';

/**
 * {@docCategory HorizontalSpacer}
 */
export interface HorizontalSpacerProps {
   /**
    * The size of the spacer.
    *
    * @defaultvalue medium
    */
   size?: 'small' | 'medium' | 'large';

   /**
    * Sets a className on the component.
    */
   className?: string;

   /**
    * Sets styles on the component.
    */
   style?: CSSProperties;
}

export const HorizontalSpacer = (props: HorizontalSpacerProps) => {
   const size = props.size || 'medium';

   return (
      <div className={`uf-spacer-horizontal-${size} ${props.className || ''}`} style={props.style}/>
   );
};
